import { render } from "./RestartDomainTransfer.vue?vue&type=template&id=1d7e789a"
import script from "./RestartDomainTransfer.vue?vue&type=script&lang=js"
export * from "./RestartDomainTransfer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__